// Sistema de días importantes en numerología
export const IMPORTANT_DAYS = {
  3: {
    emoji: "🌟",
    label: "Popularidad y Ventas",
    description: "Día ideal para networking, presentaciones y actividades comerciales. La energía favorece la conexión con otros y el éxito en ventas."
  },
  8: {
    emoji: "💰",
    label: "Expansión Económica",
    description: "Momento perfecto para inversiones, negociaciones financieras y movimientos económicos. La energía favorece el crecimiento material."
  },
  11: {
    emoji: "💡",
    label: "Vibración Maestra",
    description: "Día de inspiración y visión estratégica. Ideal para planificar a largo plazo, formalizar proyectos y conectar con ideas elevadas."
  },
  22: {
    emoji: "🚀",
    label: "Vibración Maestra",
    description: "Día de superación de obstáculos y construcción mayor. Perfecto para proyectos ambiciosos y romper barreras personales."
  }
};

// Función para verificar si un día es importante
export const isImportantDay = (personalDayNumber) => {
  return IMPORTANT_DAYS.hasOwnProperty(personalDayNumber);
};

// Función para obtener información del día importante
export const getImportantDayInfo = (personalDayNumber) => {
  return IMPORTANT_DAYS[personalDayNumber] || null;
};

// Función para obtener el color de fondo para días importantes
export const getImportantDayColor = (personalDayNumber) => {
  switch (personalDayNumber) {
    case 3:
      return "bg-yellow-50 border-yellow-200"; // Popularidad - amarillo
    case 8:
      return "bg-green-50 border-green-200";   // Economía - verde
    case 11:
      return "bg-blue-50 border-blue-200";     // Inspiración - azul
    case 22:
      return "bg-morado/5 border-morado/20"; // Maestro - púrpura
    default:
      return "";
  }
};

// Función para obtener el color de texto para días importantes
export const getImportantDayTextColor = (personalDayNumber) => {
  switch (personalDayNumber) {
    case 3:
      return "text-yellow-700"; // Popularidad
    case 8:
      return "text-green-700";  // Economía
    case 11:
      return "text-blue-700";   // Inspiración
    case 22:
      return "text-morado"; // Maestro
    default:
      return "text-gray-700";
  }
};
